import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { on } from "@ember/modifier";
import { htmlSafe, type TrustedHTML } from "@ember/template";

import { balanceRows, type Image } from "#src/index.ts";

// Reuse the component's own CSS module so the "CSS only" view is literally the
// ImageGrid styling with the JS switched off, not a lookalike. Imported by
// relative path because the `#src/*` subpath map doesn't carry the
// `.css.d.ts` type resolution that a plain relative import does.
import styles from "../../src/components/image-grid.module.css";
import { images } from "../images.ts";

function aspectRatio(image: Image): TrustedHTML {
  if (image.width == null || image.height == null) return htmlSafe("");

  return htmlSafe(`aspect-ratio: ${image.width / image.height} / 1;`);
}

// The list items, shared by both branches below so the one and only
// difference between "CSS only" and "with JS" is the balanceRows modifier.
const Items = <template>
  {{#each images key="src" as |image|}}
    <li style={{aspectRatio image}}>
      <img src={{image.src}} alt="" loading="lazy" />
    </li>
  {{/each}}
</template>;

export default class CssAndJs extends Component {
  @tracked balanced = false;

  toggle = (event: Event): void => {
    this.balanced = (event.target as HTMLInputElement).checked;
  };

  <template>
    <label class="control balance-toggle">
      <input type="checkbox" checked={{this.balanced}} {{on "change" this.toggle}} />
      Balance rows (add the JS modifier)
    </label>

    {{#if this.balanced}}
      <ul class={{styles.imageGrid}} {{balanceRows}}>
        <Items />
      </ul>
    {{else}}
      <ul class={{styles.imageGrid}}>
        <Items />
      </ul>
    {{/if}}
  </template>
}
